// Universal <MemberLink> — renders a member's name as a clickable link to
// the canonical rich profile page (/player/:id) when a profileId is provided;
// falls back to plain text otherwise (e.g. manual tournament entries with no
// linked profile).
//
// Phase C1.6 note: this component is the ONE canonical way to link a name to
// a profile across the app. The `/player/:id` route accepts EITHER a
// `players.id` OR a `profiles.id`, so callers can pass whichever is at hand
// (e.g. `challenger_id` from a challenge, or `player1_profile_id` from a
// tournament entry). Do not re-introduce `/profile/:id` links.
//
// Usage:
//   <MemberLink profileId={p.player1_profile_id} name={p.player1_name} />
//   <MemberLink profileId={ch.challenger_id} name={ch.challenger_name} />
//
// If no profileId, the child text renders as-is, preserving manual entries.
import React from 'react';
import { Link } from 'react-router-dom';

export default function MemberLink({ profileId, name, className = '', testid, children }) {
  const label = children ?? name ?? '';
  if (!profileId) {
    return <span className={className} data-testid={testid}>{label}</span>;
  }
  return (
    <Link
      to={`/player/${profileId}`}
      className={`text-inherit hover:text-[#015e3f] hover:underline underline-offset-2 transition-colors ${className}`}
      data-testid={testid || `member-link-${profileId}`}
      onClick={(e) => e.stopPropagation()}
    >
      {label}
    </Link>
  );
}
